import { render, staticRenderFns } from "./feereturn-apply.vue?vue&type=template&id=f828db1a&scoped=true&"
import script from "./feereturn-apply.vue?vue&type=script&lang=js&"
export * from "./feereturn-apply.vue?vue&type=script&lang=js&"
import style0 from "./feereturn-apply.vue?vue&type=style&index=0&id=f828db1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f828db1a",
  null
  
)

export default component.exports